import { render, staticRenderFns } from "./q3.vue?vue&type=template&id=2450c5be&scoped=true&"
import script from "./q3.vue?vue&type=script&lang=js&"
export * from "./q3.vue?vue&type=script&lang=js&"
import style0 from "./q3.vue?vue&type=style&index=0&id=2450c5be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450c5be",
  null
  
)

export default component.exports